import React, { Component } from 'react';

import { HeatMap } from 'google-maps-react';


class HealthIndexesMap extends Component {

    componentDidMount() {
        this.loadHealthIndexesMap();
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.ohlsList.length !== nextProps.ohlsList.length
            || this.props.showHealthIndexes !== nextProps.showHealthIndexes) {
            return true;
        }
        else {
            return false;
        }
        //else return false;
    }

    componentDidUpdate() {
        this.loadHealthIndexesMap();
    }

    loadHealthIndexesMap() {

        let resultElement = null;
        let healthIndexPositionsList = [];
        if (this.props.showHealthIndexes) {
            this.props.ohlsList.forEach(ohl => {

                let polesWithHealthIndex = ohl.stubovi.filter(stub => stub.hasOwnProperty('healthIndex'));
                if (polesWithHealthIndex && polesWithHealthIndex.length > 0) {
                    polesWithHealthIndex.forEach(pole => {
                        let numberOfRepetiotion = 1;
                        switch (pole.healthIndex) {
                            case 'red': numberOfRepetiotion = 3; break;
                            case 'orange': numberOfRepetiotion = 2; break;
                            default: numberOfRepetiotion = 1; break;
                        }

                        for (let i = 0; i <= numberOfRepetiotion; i++) {
                            healthIndexPositionsList.push(pole)
                        }
                    });
                }
            });

            resultElement =
                <HeatMap
                    //gradient={gradient}
                    positions={healthIndexPositionsList}
                    opacity={1}
                    radius={10}
                    dissipating={true}
                    key={Math.random()}
                />;
        }

        this.props.sendChildElementDataToState(this.props.stateElementName, resultElement);
    }

    render() {
        return null;
    }
}


export default HealthIndexesMap;
